import { toast } from "react-toastify";
import React from "react";
import { useLocation } from "react-router-dom";
import M from "materialize-css";

import { DefaultToast } from "../components/CustomToast";

export const handleError = (error) => {
  toast.error(error.response ? error.response?.data : error.message);
};

export const editAppTitle = (newTitle) => {
  document.title = `${newTitle}`;
};

export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const isTabletOrMobile = window.innerWidth < 768;

export function notify(msg, descrip) {
  if (typeof msg === "string") {
    toast(
      <DefaultToast
        notification={{
          body: descrip,
          title: msg,
        }}
      />,
      {
        position: toast.POSITION.BOTTOM_LEFT,
        hideProgressBar: true,
        autoClose: 3000,
      }
    );
    return;
  }

  toast(
    <DefaultToast
      notification={{
        body: msg.body,
        title: msg.title,
      }}
    />,
    {
      position: toast.POSITION.BOTTOM_LEFT,
      autoClose: 4000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      closeButton: false,
      progress: undefined,
    }
  );
}

export function notifyError(msg) {
  toast.error(msg, {
    position: toast.POSITION.BOTTOM_LEFT,
    hideProgressBar: true,
    autoClose: 3000,
  });
}

export function calculateTotal(item) {
  if (!item.completed) return 0;
  const scrap = item.scraps.length ? item.scraps[0] : item.scrap;
  const { quantity, quantityUnit } = scrap;
  let scrapPrice = scrap.price;
  scrapPrice = parseFloat(scrapPrice);
  let tonnesToKg =
    quantityUnit === "KG" ? parseFloat(quantity) : parseFloat(quantity) * 1000;

  if (!quantity) return 0;
  return (tonnesToKg * scrapPrice).toLocaleString();
}

export function playSound() { }

export function onNotificationClick(data, navigate) {
  const pickups = [
    "pickup_assigned",
    "pickup_completed",
    "pickup_requested",
    "driver_arrived",
    "pickup_ignored",
  ];

  if (pickups.includes(data.notificationType))
    return navigate("/timeline/" + data.pickup);

  return navigate("/pickups");
}

export const checkForProcessor = (groupId, contract) => {
  if (contract?.processorGroup === groupId) return true;
};

export const checkForGenerator = (groupId, contract) => {
  if (contract?.generatorGroup === groupId) return true;
};

export function decimalToPercentage(decimal) {
  return (decimal * 100).toString() + "%";
}

export function calculateInvoiceTotal(scrapPrice, quantityInTonnes, TCS) {
  scrapPrice = parseFloat(scrapPrice);
  let tonnesToKg = parseFloat(quantityInTonnes) * 1000;

  if (!quantityInTonnes) return 0;
  let amount = tonnesToKg * scrapPrice;

  TCS = amount * TCS;

  return (amount + TCS).toLocaleString();
}

export function showStatus(pickup) {
  if (pickup.ignored) return <span style={{ color: "#FF00EE" }}>Ignored</span>;
  if (pickup.completed)
    return <span style={{ color: "#FF00EE" }}>Ignored</span>;
  return <span style={{ color: "#FF00EE" }}>Pending</span>;
}

const currentDate = new Date();
export const isToday = (givenDate) => {
  return (
    currentDate.getFullYear() === givenDate.getFullYear() &&
    currentDate.getMonth() === givenDate.getMonth() &&
    currentDate.getDate() === givenDate.getDate()
  );
};

export const showAmount = (amount) => {
  return amount?.toLocaleString();
};

export const showAmountWithCurrency = (amount, curr) => {
  return curr
    ? curr + " " + amount?.toLocaleString()
    : "₹" + amount?.toLocaleString();
};

export const generateColor = () => {
  // Generate a random dark color
  const r = Math.floor(Math.random() * 100);
  const g = Math.floor(Math.random() * 100);
  const b = Math.floor(Math.random() * 100);

  // Convert the RGB values to a hexadecimal string
  return `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export const twoDecimals = (num) => {
  return num.toFixed(2);
};

export const getDistance = (lat1, lon1, lat2, lon2) => {
  const toRadians = (deg) => (deg * Math.PI) / 180;

  const R = 6371; // Radius of the Earth in km
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
    Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km

  return distance;
};

export const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


export function notifySuccess(msg) {
  document.body.style.overflow = "auto";
  toast.success(msg, {
    // position: toast.POSITION.BOTTOM_LEFT,
    hideProgressBar: true,
    autoClose: 2000,
  });
}


export const auctionTypeStyle = (type) => {
  if (type === "reverseAuctionService") {
    return "Reverse Service Auction";
  }
  else if (type === "reverseAuctionProduct") {
    return "Reverse Product Auction";
  } else {
    return "Forward Auction";
  }
};


export function calculateRemainingTime(endTime) {
  if (!endTime) return 0;
  const now = new Date().getTime();
  const end = new Date(endTime).getTime();
  return Math.max(end - now, 0);
}


export const truncateText = (text, maxLength) => {
  if (!text) return "";
  if (text?.length <= maxLength) {
    return text;
  }
  return text?.substring(0, maxLength) + "...";
};

export const roundToThreeDecimal = (num) => {
  if (!num) return 0
  return Math.round(num * 1000) / 1000;
};